module.exports = __webpack_public_path__ + "img/zip_ico.56e33319.png";